import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { ConfirmationModalComponent } from '@components/confirmation-modal/confirmation-modal.component';
import {
  basicConfirmModalContent,
  confirmModalContent,
  deleteModalContent,
  leaveFormModalContent,
  ModalContent,
} from '@components/confirmation-modal/confirmationModalsData';
import { BsModalService } from 'ngx-bootstrap/modal';

export enum ModalType {
  BASIC = 'basic',
  CONFIRM = 'confirm',
  DELETE = 'delete',
  LEAVE = 'leave',
}

@Directive({
  selector: '[appConfirmationModal]',
})
export class ConfirmationModalDirective {
  @Input() appConfirmationModal: ModalType;
  @Input() confirmationMessage: string;
  @Output() confirmed = new EventEmitter<boolean>();

  private modalContents = {
    basic: basicConfirmModalContent,
    confirm: confirmModalContent,
    delete: deleteModalContent,
    leave: leaveFormModalContent,
  };

  constructor(private readonly modalService: BsModalService) {}

  @HostListener('click', ['$event'])
  openConfirmationModal(event: Event): void {
    event.stopPropagation();
    let content: ModalContent;
    if (this.appConfirmationModal) {
      if (this.confirmationMessage) {
        content = {
          ...this.modalContents[this.appConfirmationModal],
          message: this.confirmationMessage,
        };
      } else {
        content = { ...this.modalContents[this.appConfirmationModal] };
      }
      const modal = this.modalService.show(ConfirmationModalComponent, {
        class: 'modal-dialog-centered modal-dialog-scrollable',
        initialState: content,
      });
      modal.content.emitData.subscribe((didConfirm: boolean) => {
        if (didConfirm) {
          this.confirmed.emit(true);
        }
      });
    } else {
      this.confirmed.emit(true);
    }
  }
}
